export default __webpack_public_path__ + "static/media/hamburger.0f6f9063.svg";